import * as sdkTypes from '@vansite/ts-sharetribe-flex-sdk/types';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.propTypes.place) properties.
const defaultLocations = (locale) => {
  switch (locale) {
    case 'de':
      return [
        // Adding default-germany to the German locales if it should be used for generic Germany
        {
          id: 'default-germany',
          predictionPlace: {
            address: 'Deutschland',
            bounds: new LatLngBounds(
              new LatLng(55.1286491, 15.041832),
              new LatLng(47.270238, 5.866315),
            ),
          },
        },
        {
          id: 'default-allgaeu',
          predictionPlace: {
            address: 'Allgäu, Deutschland',
            bounds: new LatLngBounds(
              new LatLng(49.04181157, 11.65524952),
              new LatLng(46.73392268, 9.30210416),
            ),
          },
        },
        {
          id: 'default-nordsee',
          predictionPlace: {
            address: 'Nordsee, Deutschland',
            bounds: new LatLngBounds(
              new LatLng(54.82760494, 9.56126824),
              new LatLng(52.97850623, 6.96925275),
            ),
          },
        },
        {
          id: 'default-ostsee',
          predictionPlace: {
            address: 'Ostsee, Deutschland',
            bounds: new LatLngBounds(
              new LatLng(56.18286645, 14.48499558),
              new LatLng(52.52706922, 9.30096461),
            ),
          },
        },
        {
          id: 'default-bayern',
          predictionPlace: {
            address: 'Bayern, Deutschland',
            bounds: new LatLngBounds(
              new LatLng(50.564694, 13.839619),
              new LatLng(47.270238, 8.97636),
            ),
          },
        },
        {
          id: 'default-sauerland',
          predictionPlace: {
            address: 'Sauerland, Deutschland',
            bounds: new LatLngBounds(
              new LatLng(51.478705, 8.52843),
              new LatLng(51.029548, 7.810779),
            ),
          },
        },
        {
          id: 'default-harz',
          predictionPlace: {
            address: 'Harz, Deutschland',
            bounds: new LatLngBounds(
              new LatLng(51.941245, 10.762483),
              new LatLng(51.492088, 10.037516),
            ),
          },
        },
      ];
    case 'it':
      return [
        {
          id: 'default-italy',
          predictionPlace: {
            address: 'Italia',
            bounds: new LatLngBounds(
              new LatLng(47.092146, 18.6201843),
              new LatLng(35.4122073, 6.626556),
            ),
          },
        },
        {
          id: 'default-suedtirol',
          predictionPlace: {
            address: 'Alto Adige, Italia',
            bounds: new LatLngBounds(
              new LatLng(47.092146, 12.477916),
              new LatLng(46.219772, 10.381822),
            ),
          },
        },
        {
          id: 'default-lombardei',
          predictionPlace: {
            address: 'Lombardia, Italia',
            bounds: new LatLngBounds(
              new LatLng(46.6351853, 11.4276993),
              new LatLng(44.6796491, 8.4978605),
            ),
          },
        },
        {
          id: 'default-sizilien',
          predictionPlace: {
            address: 'Sicilia, Italia',
            bounds: new LatLngBounds(
              new LatLng(38.8121854, 15.6527947),
              new LatLng(35.4929687, 11.9253334),
            ),
          },
        },
        {
          id: 'default-toskana',
          predictionPlace: {
            address: 'toscana, Italia',
            bounds: new LatLngBounds(
              new LatLng(44.4726899, 12.3713555),
              new LatLng(42.2376686, 9.6867213),
            ),
          },
        },
        {
          id: 'default-ligurien',
          predictionPlace: {
            address: 'Liguria, Italia',
            bounds: new LatLngBounds(
              new LatLng(44.6764264, 10.0710317),
              new LatLng(43.7596721, 7.4948099),
            ),
          },
        },
      ];
    case 'fr':
      return [
        {
          id: 'default-france',
          predictionPlace: {
            address: 'France',
            bounds: new LatLngBounds(
              new LatLng(51.1504571, 9.6598888),
              new LatLng(41.3108239, -5.2425456),
            ),
          },
        },
        {
          id: 'default-nouvelle-aquitaine ',
          predictionPlace: {
            address: 'Nouvelle-Aquitaine, France',
            bounds: new LatLngBounds(
              new LatLng(47.175758, 2.611568),
              new LatLng(42.777717, -1.808998),
            ),
          },
        },
        {
          id: 'default-bretagne',
          predictionPlace: {
            address: 'Bretagne, France',
            bounds: new LatLngBounds(
              new LatLng(48.90097220000001, -1.0156128),
              new LatLng(47.2778937, -5.1412765),
            ),
          },
        },
        {
          id: 'default-okzitanien',
          predictionPlace: {
            address: 'Cccitanie, France',
            bounds: new LatLngBounds(
              new LatLng(45.046691, 4.845553),
              new LatLng(42.333036, -0.327172),
            ),
          },
        },
        {
          id: 'default-provence-alpes-cote-d-azur',
          predictionPlace: {
            address: 'Provence-Alpes-Côte d\'Azur, France',
            bounds: new LatLngBounds(
              new LatLng(45.126848, 7.718919),
              new LatLng(42.909235, 4.21875),
            ),
          },
        },
        {
          id: 'default-auvergne-rhone-alpes',
          predictionPlace: {
            address: 'Auvergne-Rhône-Alpes, France',
            bounds: new LatLngBounds(
              new LatLng(46.803995, 7.185755),
              new LatLng(44.115453, 2.062914),
            ),
          },
        },
      ];
    case 'es':
      return [
        {
          id: 'default-spain',
          predictionPlace: {
            address: 'España',
            bounds: new LatLngBounds(
              new LatLng(43.8640692, 4.4264828),
              new LatLng(27.5545087, -18.260243),
            ),
          },
        },
        {
          id: 'default-andalusien',
          predictionPlace: {
            address: 'Andalucía, España',
            bounds: new LatLngBounds(
              new LatLng(38.7290872, -1.6301238),
              new LatLng(35.9376148, -7.5228775),
            ),
          },
        },
        {
          id: 'default-katalonien',
          predictionPlace: {
            address: 'Cataluña, España',
            bounds: new LatLngBounds(
              new LatLng(42.861424, 3.3325539),
              new LatLng(40.5230466, 0.1591811),
            ),
          },
        },
        {
          id: 'default-asturien',
          predictionPlace: {
            address: 'Asturianos, España',
            bounds: new LatLngBounds(
              new LatLng(43.7386187, -4.5076836),
              new LatLng(42.882543, -7.182483),
            ),
          },
        },
        {
          id: 'default-barcelona',
          predictionPlace: {
            address: 'Barcelona, España',
            bounds: new LatLngBounds(
              new LatLng(42.323302, 2.8125),
              new LatLng(41.1206863, 1.360412),
            ),
          },
        },
        {
          id: 'default-madrid',
          predictionPlace: {
            address: 'Madrid, España',
            bounds: new LatLngBounds(
              new LatLng(41.165845, -3.052983),
              new LatLng(39.884719, -4.579076),
            ),
          },
        },
      ];
    default:
      return [
        {
          id: 'default-europe',
          predictionPlace: {
            address: 'Europe',
            bounds: new LatLngBounds(
              new LatLng(59.68940654, 19.07422688),
              new LatLng(30.17883172, -11.8484966),
            ),
          },
        },
        {
          id: 'default-germany',
          predictionPlace: {
            address: 'Germany',
            bounds: new LatLngBounds(
              new LatLng(55.1286491, 15.041832),
              new LatLng(47.270238, 5.866315),
            ),
          },
        },
        {
          id: 'default-france',
          predictionPlace: {
            address: 'France',
            bounds: new LatLngBounds(
              new LatLng(51.1504571, 9.6598888),
              new LatLng(41.3108239, -5.2425456),
            ),
          },
        },
        {
          id: 'default-italy',
          predictionPlace: {
            address: 'Italy',
            bounds: new LatLngBounds(
              new LatLng(47.092146, 18.6201843),
              new LatLng(35.4122073, 6.626556),
            ),
          },
        },
        {
          id: 'default-spain',
          predictionPlace: {
            address: 'Spain',
            bounds: new LatLngBounds(
              new LatLng(43.8640692, 4.4264828),
              new LatLng(27.5545087, -18.260243),
            ),
          },
        },
        {
          id: 'default-norway-and-sweden',
          predictionPlace: {
            address: 'Norway and Sweden',
            bounds: new LatLngBounds(
              new LatLng(66.53721479, 21.59158972),
              new LatLng(55.48308506, 2.53469984),
            ),
          },
        },
      ];
  }
};
export default defaultLocations;
